export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'SystemProfileManagement': 'System Profile Management',
            'Roles': 'Roles',
            'MyProfile': 'My Profile',
            'SAMPLE'        : {
                'TITLE': 'Sample',
                'BADGE': '25'
            }
        }
    }
};
